<script>
// import Translations from "./insert-me-to-translate.vue";

import { reactive, ref, inject } from '@vue/composition-api'
import { voucherApi } from "./vouch-digital-client"

export default {
    setup(_, ctx) {
        const response_status_success = 'success'
        const response_status_fail = 'fail'
        const store = ctx.root.$store
        const trans = {
            "title_convert": gettext("Do you have a <b>Vouch Digital</b> voucher? Convert it to credits"),
            "convert": gettext("CONVERT"),
            "voucher_not_found": gettext("Voucher not found"),
            "voucher_not_purchased": gettext("Voucher not purchased"),
            "insert_the_voucher": gettext("Insert the voucher")
        }

        const validateUrl = inject('validateUrl')
        const voucherCredits = inject('voucherCredits')
        const cookies = inject('cookies')
        const voucherValue = inject('voucher')
        const status = inject('status')
        const status_checked = inject('status_checked')
        const errorMessage = ref(null)
        const voucher = reactive({
            value: voucherValue,
            validated: true
        })
        const validate = () => {
            const re = /^VOUCH-[A-Z0-9]{10}$/i
            voucher.validated = re.test(voucher.value)
            console.log(`Validated ${voucher.validated}`)
            return voucher.validated
        }
        const setErrorMessage = (message) => {
            errorMessage.value = message
            voucher.validated = (message === null)
        }

        const checkVoucher = () => {
            console.log(cookies)
            console.log(cookies.value.get('csrftoken'))
            if (validate()) {
                store.dispatch("ui/loader/show")
                voucherApi(voucher.value, validateUrl, cookies.value.get('csrftoken')).then((response) => {
                    try {
                        const response_status = response.data.status
                        if (response_status === response_status_success) {
                            voucherCredits.value = response.data.data.credits
                            status.value = status_checked
                            setErrorMessage(null)
                        } else {
                            const message = response.data.data.message
                            setErrorMessage(message)
                        }
                        
                    } catch {
                        voucherCredits.value = null
                    }
                    store.dispatch("ui/loader/hide")
                }).catch((error) => {
                    const response = error.response
                    const status = response.status
                    console.log("catch")
                    console.log(response)

                    if ((status === 404) || (status === 405)){
                        setErrorMessage(trans.voucher_not_found)
                    } else if (status === 406) {
                        setErrorMessage(trans.voucher_not_purchased)
                    }
                    voucher.validated = false
                    store.dispatch("ui/loader/hide")
                })
            }
        }
        return {
            trans,
            voucher,
            checkVoucher,
            validateUrl,
            cookies,
            errorMessage
        }
    },
    mounted() {

    }
}
</script>
<template>
    <div>
        <div class="col">
            <h4 class="d-flex justify-content-between align-items-center">
                <span v-html="trans.title_convert"></span>
            </h4>
        </div>
        <div class="col mt-4">
            <form @submit.prevent="checkVoucher">
                <div class="form-group">
                    <input type="text" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" autocomplete="off"
                        :placeholder="trans.insert_the_voucher" v-model="voucher.value"
                        :class="!voucher.validated || errorMessage ? 'is-invalid' : ''">
                    <div v-if="errorMessage" class="invalid-feedback">
                        {{ errorMessage }}
                    </div>
                </div>
                <button class="btn btn-primary">{{ trans.convert }}</button>
            </form>
        </div>
    </div>
</template>